import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;500;600;700&family=Montserrat:wght@300;400;500;600;700&display=swap');
  
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
  
  html {
    font-size: 16px;
    scroll-behavior: smooth;
  }
  
  body {
    font-family: ${props => props.theme.fonts.secondary};
    color: ${props => props.theme.colors.dark};
    background-color: ${props => props.theme.colors.light};
    line-height: 1.6;
    overflow-x: hidden;
  }
  
  h1, h2, h3, h4, h5, h6 {
    font-family: ${props => props.theme.fonts.main};
    margin-bottom: ${props => props.theme.spacing.md};
    font-weight: 600;
    line-height: 1.3;
  }
  
  h1 {
    font-size: ${props => props.theme.fontSizes.xxxlarge};
  }
  
  h2 {
    font-size: ${props => props.theme.fontSizes.xxlarge};
  }
  
  h3 {
    font-size: ${props => props.theme.fontSizes.xlarge};
  }
  
  p {
    margin-bottom: ${props => props.theme.spacing.md};
  }
  
  a {
    color: ${props => props.theme.colors.primary};
    text-decoration: none;
    transition: ${props => props.theme.transitions.short};
    
    &:hover {
      color: ${props => props.theme.colors.secondary};
    }
  }
  
  img {
    max-width: 100%;
    height: auto;
  }
  
  button {
    cursor: pointer;
    font-family: ${props => props.theme.fonts.secondary};
  }
  
  ul, ol {
    margin-left: ${props => props.theme.spacing.lg};
    margin-bottom: ${props => props.theme.spacing.md};
  }
  
  section {
    padding: ${props => props.theme.spacing.xxl} 0;
  }
  
  .container {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 ${props => props.theme.spacing.md};
  }
  
  .text-center {
    text-align: center;
  }
  
  .mb-1 {
    margin-bottom: ${props => props.theme.spacing.sm};
  }
  
  .mb-2 {
    margin-bottom: ${props => props.theme.spacing.md};
  }
  
  .mb-3 {
    margin-bottom: ${props => props.theme.spacing.lg};
  }
  
  .mb-4 {
    margin-bottom: ${props => props.theme.spacing.xl};
  }
  
  .mb-5 {
    margin-bottom: ${props => props.theme.spacing.xxl};
  }
  
  .mt-1 {
    margin-top: ${props => props.theme.spacing.sm};
  }
  
  .mt-2 {
    margin-top: ${props => props.theme.spacing.md};
  }
  
  .mt-3 {
    margin-top: ${props => props.theme.spacing.lg};
  }
  
  .mt-4 {
    margin-top: ${props => props.theme.spacing.xl};
  }
  
  .mt-5 {
    margin-top: ${props => props.theme.spacing.xxl};
  }
  
  /* Animations */
  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
  
  @keyframes slideUp {
    from {
      transform: translateY(50px);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }
  
  @keyframes slideDown {
    from {
      transform: translateY(-50px);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }
  
  @keyframes slideLeft {
    from {
      transform: translateX(50px);
      opacity: 0;
    }
    to {
      transform: translateX(0);
      opacity: 1;
    }
  }
  
  @keyframes slideRight {
    from {
      transform: translateX(-50px);
      opacity: 0;
    }
    to {
      transform: translateX(0);
      opacity: 1;
    }
  }
  
  .fade-in {
    animation: fadeIn 1s ease-in-out;
  }
  
  .slide-up {
    animation: slideUp 1s ease-in-out;
  }
  
  .slide-down {
    animation: slideDown 1s ease-in-out;
  }
  
  .slide-left {
    animation: slideLeft 1s ease-in-out;
  }
  
  .slide-right {
    animation: slideRight 1s ease-in-out;
  }
`;

export default GlobalStyle;
